import { render, staticRenderFns } from "./ExtendedMultiChart.vue?vue&type=template&id=45df2281&scoped=true"
import script from "./ExtendedMultiChart.vue?vue&type=script&lang=ts"
export * from "./ExtendedMultiChart.vue?vue&type=script&lang=ts"
import style0 from "./ExtendedMultiChart.vue?vue&type=style&index=0&id=45df2281&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df2281",
  null
  
)

export default component.exports